import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  message,
} from "antd";
import axios from "axios";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import { serverUrl } from "../../../../../nestserver";

const AdmissionHomePage = () => {
  const { Option } = Select;
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const [addSubject, setAddSubject] = useState(false);
  const [viewMessage, setViewMessage] = useState(false);
  const [selectedRecord] = useState(null);

  // fetch applications
  async function fetchApplications() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/parent/application/list/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const applications = useQuery("applications", fetchApplications);

  // fetch classes
  async function fetchClasses() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/classes/",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const classes = useQuery("classes", fetchClasses);

  // fetch departments
  async function fetchDepartments() {
    const response = await axios.get(serverUrl + "/department", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return response.data;
  }
  const departments = useQuery("departments", fetchDepartments);

  // Table Settings

  // Search Filter

  const [, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const searchInputRef = useRef(null);

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInputRef}
          placeholder={`Search Subject`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={
              <SearchOutlined
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            }
            size="small"
            style={{ width: 90, display: "inline-flex", alignItems: "center", justifyContent: "center" }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInputRef.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex
        ? // <Highlighter
          //   highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          //   searchWords={[searchText]}
          //   autoEscape
          //   textToHighlight={text ? text.toString() : ''}
          // />
          text
        : text,
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "Application No.",

      key: "",
      align: "center",
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className=" text-base font-semibold text-center"
        >
          {record?.application_number}
        </div>
      ),
    },
    {
      title: "Name",
      key: "name",
      align: "center",
      ...getColumnSearchProps(["first_name", "last_name"]),
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className=" text-base font-semibold text-center capitalize"
        >
          {record?.first_name + " " + record?.last_name}
        </div>
      ),
      onFilter: (value, record) =>
        (
          record?.first_name?.toLowerCase() +
          " " +
          record?.last_name?.toLowerCase()
        ).includes(value.toLowerCase()),
    },
    {
      title: "Class",
      dataIndex: "classData",
      key: "class",
      align: "center",
      ...getColumnSearchProps("classData"),
      render: (classData) => (
        <div
          key={classData?._id}
          style={{ color: "#111111" }}
          className="text-base font-semibold text-center"
        >
          {classData?.name}
        </div>
      ),
      onFilter: (value, record) =>
        record.classData?.name.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Application Date",
      dataIndex: ["createdAt"],
      key: "createdAt",
      sorter: (a, b) => (moment(a?.createdAt).isBefore(b?.createdAt) ? 1 : -1),
      render: (text) => (
        <div style={{ color: "#616161" }} className=" text-base">
          {moment(text).format("Do MMM YYYY")}
        </div>
      ),
    },
    {
      title: "Accepted Date",
      dataIndex: ["accepted_at"],
      key: "createdAt",
      sorter: (a, b) =>
        moment(a?.accepted_at).isBefore(b?.accepted_at) ? 1 : -1,
      render: (text) => (
        <div style={{ color: "#616161" }} className=" text-base">
          {text ? moment(text).format("Do MMM YYYY") : "---"}
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: ["status"],
      key: "",
      align: "center",
      sorter: (a, b) => a.status.localeCompare(b.status),
      render: (record) => (
        <div
          key={record?._id}
          style={{ color: "#111111" }}
          className=" text-base font-semibold text-center capitalize"
        >
          {record}
        </div>
      ),
    },
    {
      /*{
      title: "Message",
      dataIndex: "message",
      key: "message",
      align: "center",
      render: (record) => {
        if (!record) {
          return (
            <div className="text-base text-gray-400 cursor-not-allowed">
              View
            </div>
          );
        }

        return (
          <div
            className="text-base font-semibold text-center text-blue-500 cursor-pointer"
            onClick={() => {
              setSelectedRecord(record);
              setViewMessage(true);
            }}
          >
            View
          </div>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (record) => (
        <div
          key={record?._id}
          className=" text-base font-semibold text-center text-blue-500 cursor-pointer"
          onClick={() =>
            history.push(`/dashboard/parent/menu/admission/${record?._id}`)
          }
        >
          View
        </div>
      ),
    },
    }*/
    },
  ];

  function createSubject(values) {
    setAddSubject(false);
    axios
      .post(serverUrl + "/subjects", values, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      })
      .then((res) => {
        message.success("Subject Created");
        form.resetFields();
        queryClient.invalidateQueries("subjects");
      })
      .catch((error) => {
        if (error?.response?.data) {
          message.error(error?.response?.data.message);
        } else {
          message.error(error.message);
        }
      });
  }

  return (
    <>
      <div className="mt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          <div className="text-2xl text-orange-500 font-semibold">
            Admission
          </div>
          <div className="py-5">
            <Table
              columns={columns}
              dataSource={
                applications.isSuccess
                  ? applications?.data?.data?.sort((a, b) =>
                      moment(a?.createdAt).isBefore(b?.createdAt) ? 1 : -1
                    )
                  : []
              }
              pagination={true}
              loading={applications.isLoading}
            />
          </div>
        </div>
      </div>
      {/* ----------------------------------modal------------------------------------ */}

      <Modal
        width={800}
        visible={viewMessage}
        onCancel={() => {
          setViewMessage(false);
        }}
        footer={null}
      >
        {selectedRecord ? (
          <div className="pt-4 text-base">{selectedRecord}</div>
        ) : (
          <div className="pt-5 text-base">No Message</div>
        )}
      </Modal>

      <Modal
        width={800}
        visible={addSubject}
        onCancel={() => {
          setAddSubject(false);
          form.resetFields();
        }}
        footer={null}
      >
        <div>
          <div className="py-2">
            <div className="text-2xl font-bold text-black pb-4 capitalize">
              Add Subject
            </div>
          </div>
          {/* ---------------------------form---------------- */}
          <div>
            <Form
              form={form}
              layout="vertical"
              name="basic"
              onFinish={createSubject}
              autoComplete="off"
            >
              <Form.Item
                label="Subject Name"
                name="name"
                rules={[
                  { required: true, message: "Please input name for subject" },
                ]}
              >
                <Input className="w-full" />
              </Form.Item>

              <Form.Item
                label="Class"
                name="class"
                className="w-full "
                rules={[
                  {
                    required: true,
                    message: "Please select a class for the subject",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  allowClear
                  placeholder="Select Class"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  style={{
                    border: "6px",
                    backgroundColor: "#EBEBEB",
                  }}
                >
                  {classes.isSuccess &&
                    classes?.data?.map((data) => {
                      return (
                        <Option key={data._id} value={data._id}>
                          {data.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>

              <Form.Item
                label="Department"
                name="department"
                className="w-full "
                rules={[
                  {
                    required: true,
                    message: "Please select a department for the subject",
                  },
                ]}
              >
                <Select
                  showSearch
                  showArrow
                  allowClear
                  placeholder="Select Department"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children
                      .toLowerCase()
                      .localeCompare(optionB.children.toLowerCase())
                  }
                  style={{
                    border: "6px",
                    backgroundColor: "#EBEBEB",
                  }}
                >
                  {departments.isSuccess &&
                    departments?.data?.map((data) => {
                      return (
                        <Option key={data._id} value={data._id}>
                          {data.name}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <div className="flex justify-end items-center pt-6">
                <div className="inline-flex items-center space-x-2">
                  <Button
                    size="large"
                    type="dark"
                    onClick={() => {
                      setAddSubject(false);
                      form.resetFields();
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    Add Subject
                  </Button>
                </div>
              </div>
            </Form>
          </div>
          {/* ----------------------------------------------- */}
        </div>
      </Modal>
    </>
  );
};

export default AdmissionHomePage;
